<template>
  <div
    :class="{
      'border-red border bg-red-lightest hover:bg-red-lighter': !attachment.id,
    }"
    class="bg-grey-lighter rounded p-6 mt-5 hover:bg-grey-light relative"
  >
    <div class="flex items-center mb-2">
      <label class="file-name mr-4" for="file-name">Attachment Name:</label>
      <input id="file-name" readonly type="text" :value="attachment.name" />
    </div>
    <button
      class="file-selector"
      @click="$emit('OPEN_S3_UPLOAD_WIDGET', itemIndex)"
    >
      Click to open upload widget
    </button>
    <div>
      <strong :class="{ 'text-red': !attachment.id }">File ID:</strong>
      <span
        :class="{ 'text-red': !attachment.id }"
        class="inline-block mt-2 ml-2"
        >{{ attachment.id || "Not uploaded yet" }}</span
      >
    </div>
    <div class="flex items-center mt-2">
      <label for="allow-download">Allow Download </label>
      <input
        id="allow-download"
        class="ml-2"
        type="checkbox"
        :checked="attachment.can_download"
        @click="handleCanDownloadClick"
      />
      <span v-if="updated" class="text-green-dark text-sm ml-2 inline-block">
        Updated &#10004;</span
      >
    </div>
    <button
      class="remove-btn px-4 py-2 rounded-sm"
      @click="$emit('REMOVE_ATTACHMENT', itemIndex)"
    >
      REMOVE
    </button>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  props: {
    attachment: {
      type: Object,
      requred: true,
    },
    itemIndex: {
      type: Number,
      requred: true,
    },
  },
  data() {
    return {
      updated: false,
    }
  },
  methods: {
    handleCanDownloadClick(evt) {
      this.$emit("CAN_DOWNLOAD_CLICKED", {
        checked: evt.target.checked,
        itemIndex: this.itemIndex,
      })
      // do not update if file isn't uploaded
      if (this.attachment.id && this.attachment.public_url) {
        this.updateAlreadyUploadedFile()
      }
    },
    updateAlreadyUploadedFile() {
      const { id, name, public_url, can_download } = this.attachment
      this.axios({
        method: "PUT",
        url: `${siteConfig.siteURL}uploads/${id}`,
        data: { name, public_url, can_download },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        if (res.data.status) {
          this.updated = true
          setTimeout(() => {
            this.updated = false
          }, 2000)
        } else {
          this.$noty.error(res.data.message)
        }
      })
    },
  },
}
</script>
<style scoped>
.file-selector {
  position: relative;
  width: 300px;
  height: 100px;
  padding: 1rem 3rem;
  border: 1px dashed #016301;
  border-radius: 0px;
  background-color: #d5f7ad;
}

.file-selector:hover {
  color: #353535;
  background-color: #9cd858;
}

.remove-btn {
  position: absolute;
  right: 1rem;
  bottom: 1rem;
  color: red;
}

.remove-btn:hover {
  background: #fdb6b6;
}

.file-name {
  flex-shrink: 0;
}
</style>
